import type { SVGProps } from "react";
import { withCustomIcon } from "./withCustomIcon";

const ScheduledIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    className="tenera-icon"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor">
      <path
        fill="currentColor"
        d="M21.8208,2.3196h-1.7822v-.5527c0-.9365-.7617-1.6982-1.6982-1.6982s-1.6982.7617-1.6982,1.6982v.5527h-2.9219v-.5527c0-.9365-.7617-1.6982-1.6982-1.6982s-1.6982.7617-1.6982,1.6982v.5527h-2.9355v-.5527c0-.9365-.7617-1.6982-1.6982-1.6982s-1.6982.7617-1.6982,1.6982v.5527h-1.8125C.9761,2.3196-.0034,3.2986-.0034,4.5022v15.729c0,1.2031.9795,2.1826,2.1826,2.1826h10.8962c-.2067-.3163-.3885-.6501-.5409-1H2.1792c-.6523,0-1.1826-.5303-1.1826-1.1826v-12.0498h22.0068v5.226c.3653.2928.7022.6197,1,.9808V4.5022c0-1.2036-.9795-2.1826-2.1826-2.1826ZM17.6421,1.7668c0-.3853.3135-.6982.6982-.6982s.6982.313.6982.6982v2.3184c0,.3853-.3135.6982-.6982.6982s-.6982-.313-.6982-.6982V1.7668ZM11.3237,1.7668c0-.3853.3135-.6982.6982-.6982s.6982.313.6982.6982v2.3184c0,.3853-.3135.6982-.6982.6982s-.6982-.313-.6982-.6982V1.7668ZM4.9917,1.7668c0-.3853.3135-.6982.6982-.6982s.6982.313.6982.6982v2.3184c0,.3853-.3135.6982-.6982.6982s-.6982-.313-.6982-.6982V1.7668ZM23.0034,7.1814H.9966v-2.6792c0-.6519.5303-1.1826,1.1826-1.1826h1.8125v.7656c0,.9365.7617,1.6982,1.6982,1.6982s1.6982-.7617,1.6982-1.6982v-.7656h2.9355v.7656c0,.9365.7617,1.6982,1.6982,1.6982s1.6982-.7617,1.6982-1.6982v-.7656h2.9219v.7656c0,.9365.7617,1.6982,1.6982,1.6982s1.6982-.7617,1.6982-1.6982v-.7656h1.7822c.6523,0,1.1826.5308,1.1826,1.1826v2.6792Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M6.5864,10.7722c0-.478-.3887-.8667-.8662-.8667h-1.6875c-.4785,0-.8672.3887-.8672.8667v1.291c0,.478.3887.8672.8672.8672h1.6875c.4775,0,.8662-.3892.8662-.8672v-1.291ZM5.5864,11.9304h-1.4209v-1.0249h1.4209v1.0249Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M11.3696,10.7722c0-.478-.3887-.8667-.8662-.8667h-1.6875c-.4785,0-.8672.3887-.8672.8667v1.291c0,.478.3887.8672.8672.8672h1.6875c.4775,0,.8662-.3892.8662-.8672v-1.291ZM10.3696,11.9304h-1.4209v-1.0249h1.4209v1.0249Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M6.5864,14.3669c0-.478-.3887-.8667-.8662-.8667h-1.6875c-.4785,0-.8672.3887-.8672.8667v1.2915c0,.478.3887.8667.8672.8667h1.6875c.4775,0,.8662-.3887.8662-.8667v-1.2915ZM5.5864,15.5251h-1.4209v-1.0249h1.4209v1.0249Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M11.3696,14.3669c0-.478-.3887-.8667-.8662-.8667h-1.6875c-.4785,0-.8672.3887-.8672.8667v1.2915c0,.478.3887.8667.8672.8667h1.6875c.4775,0,.8662-.3887.8662-.8667v-1.2915ZM10.3696,15.5251h-1.4209v-1.0249h1.4209v1.0249Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M12.688,15.6584c0,.0055.003.01.0031.0154.4192-.8373,1.0015-1.5779,1.7124-2.1736h-.8483c-.4785,0-.8672.3887-.8672.8667v1.2915Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M5.7202,17.0955h-1.6875c-.4785,0-.8672.3887-.8672.8662v1.291c0,.4785.3887.8672.8672.8672h1.6875c.4775,0,.8662-.3887.8662-.8672v-1.291c0-.4775-.3887-.8662-.8662-.8662ZM5.5864,19.1199h-1.4209v-1.0244h1.4209v1.0244Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M10.5034,17.0955h-1.6875c-.4785,0-.8672.3887-.8672.8662v1.291c0,.4785.3887.8672.8672.8672h1.6875c.4775,0,.8662-.3887.8662-.8672v-1.291c0-.4775-.3887-.8662-.8662-.8662ZM10.3696,19.1199h-1.4209v-1.0244h1.4209v1.0244Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M13.5552,12.9304h1.6468c.2419-.1494.4927-.2849.7535-.4035.0889-.1361.1534-.2894.1534-.4637v-1.291c0-.478-.3887-.8667-.8662-.8667h-1.6875c-.4785,0-.8672.3887-.8672.8667v1.291c0,.478.3887.8672.8672.8672ZM13.688,10.9055h1.4209v1.0249h-1.4209v-1.0249Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M20.8125,12.2322c.01-.06.04-.11.04-.17v-1.29c0-.48-.39-.87-.87-.87h-1.69c-.48,0-.87.39-.87.87v1.28c.33-.07.66-.11,1-.12v-1.03h1.43v1.1c.33.05.65.13.96.23Z"
        className="primary"
      />
      <path
        fill="currentColor"
        d="M18.7612,13.4817c-2.8809,0-5.2246,2.3442-5.2246,5.2251s2.3438,5.2246,5.2246,5.2246,5.2246-2.3438,5.2246-5.2246-2.3438-5.2251-5.2246-5.2251ZM18.7612,22.9314c-2.3291,0-4.2246-1.8955-4.2246-4.2246s1.8955-4.2251,4.2246-4.2251,4.2246,1.895,4.2246,4.2251-1.8955,4.2246-4.2246,4.2246Z"
        className="primary"
      />
    </g>
    <path
      fill="currentColor"
      d="M20.939,16.99l-2.9609,2.9609-1.3086-1.2754c-.1953-.1914-.5127-.1875-.707.0098-.1924.1973-.1885.5137.0098.707l2.0156,1.9629,3.6582-3.6582c.1953-.1953.1953-.5117,0-.707s-.5117-.1953-.707,0Z"
      className="accent"
    />
  </svg>
);

export default withCustomIcon(ScheduledIcon);